import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import UserConsentRestServices from '../../services/user-consent-rest.service';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import UserService from '../../services/user.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'list-consents',
	templateUrl: './list-consents.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class ListConsentsComponent implements OnInit {
	private userConsentRestServices: UserConsentRestServices = inject(UserConsentRestServices);
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private userService: UserService = inject(UserService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	
	@Input() consent: any;
	@Output() consentChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.initialize();
		
		this.vm.user = this.session.getSession().user;
		this.vm.updateConsents = this.updateConsents;
	}
	
	initialize() {
		this.vm.isBookingConsent = typeof this.vm.consent.booking !== 'undefined';
		if (this.vm.isBookingConsent) {
			this.vm.minudocExtraConsentsDisabled = this.vm.consent.booking.service?.minudocExtraConsentsDisabled;
			if (this.vm.consent.booking.service) {
				this.vm.prescriptionBooking = this.isPrescriptionBooking(this.vm.consent.booking);
			}
			this.toggleBtnDisabledState();
		}
	}
	
	toggleBtnDisabledState() {
		if (this.vm.consent.pharmacyDataSharingAccepted || this.vm.consent.pharmacyDataProcessingAccepted) {
			this.vm.btnDisabled = false;
		} else {
			this.vm.btnDisabled = this.vm.isBookingConsent
				&& !this.vm.consent.dataProcessingAccepted
				&& !this.vm.consent.dataSharingAccepted
				&& !this.vm.consent.dataStorageTimeAccepted;
		}
	}
	
	updateConsents() {
		if (this.vm.loading) return;
		this.vm.loading = true;
		var successCallback = (res) => {
			this.angularHelperService.createTimer(() => {
				this.vm.loading = false;
				this.vm.consent._isOpen = false;
			}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
			this.toggleBtnDisabledState();
			this.userService.clearEhifData();
		};
		var errorCallback = (err) => {
			this.angularHelperService.createTimer(() => { this.vm.loading = false; }, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
		};
		if (this.vm.isBookingConsent) {
			this.userConsentRestServices.updateBookingConsents(this.vm.consent, successCallback, errorCallback);
		} else {
			this.userConsentRestServices.updateGeneralConsents(this.vm.consent, successCallback, errorCallback);
		}
	}
	
	isPrescriptionBooking(booking) {
		if (booking.bookingInstantRequest &&
			booking.bookingInstantRequest.type &&
			booking.bookingInstantRequest.type == 'PRESCRIPTION_REQUEST') {
			return true;
		}
		
		return false;
	}
	
}